module.exports = __webpack_public_path__ + "img/star.16f0697c.png";